import { E_Status } from "@/types";
import { IPageData, IPageParams } from "../types";
import { E_EnableDataDilution } from "./dataDilution.type";

export enum E_IndustryType {
    /**
     * 冶金
     */
    Metallurgy = 'Metallurgy',
    /**
     * 港口
     */
    Port = 'Port',
    /**
     * 风电/新能源
     */
    WindPowerNewEnergy = 'WindPowerNewEnergy',
    /**
     * 锂电制造
     */
    LithiumBatteryManufacturing = 'LithiumBatteryManufacturing',
    /**
     * 轨道交通
     */
    RailTransit = 'RailTransit',
    /**
     * 石油化工
     */
    Petrochemical = 'Petrochemical',
    /**
     * 工程机械
     */
    ConstructionMachinery = 'ConstructionMachinery',
    /**
     * 智能制造
     */
    IntelligentManufacturing = 'IntelligentManufacturing',

    /**
     * 未分类
     */
    Unknown = 'Unknown'
}

export interface ICustomListParams extends IPageParams {
    /**
     * 客户名称
     */
    name?: string
    status?: E_Status
}

export interface ICustomListItem {
    id: number
    /**
     * 创建时间
     */
    createTime: string
    /**
     * 到期时间
     */
    expireTime: string
    /**
     * 客户名称
     */
    companyName: string
    /**
     * 状态
     */
    status: E_Status
    /**
     * 管理账号
     */
    userName: string
    userId: number

    /**
     * 是否启用数据稀释
     */
    dataDilution: E_EnableDataDilution
}

export type ICustomListData = IPageData<ICustomListItem>

export interface ICustomItem {
    companyName: string
    userName: string
    password?: string
    status?: E_Status
    remark?: string
    logoId?: number
    platformId?: number
    /**
     * 到期时间
     */
    expireTime?: string
    email?: string

    /**
     * 加入行业类型
     */
    industryType?: E_IndustryType
}

export interface ICustomEditItem extends ICustomItem {
    id: number
    menuIds?: number[]
    menuAppIds?: number[]
}

export interface ICustomGetItem extends ICustomItem {
    id: number
    logoUrl: number
    platformUrl: number
    menus: any[]
}

export type ICustomAddParams = ICustomItem
export type ICustomEditParams = ICustomEditItem

export interface ICustomItemDetail extends ICustomItem {
    id: number
}

export interface ICustomResetPasswordParams {
    userId: number
    adminPassword: string
    newPassword: string
}

export interface ICustomEditCheckPasswordParams {
    id: number
    checkPassword: string
}

/** 0/1 类型服务开关 */
export enum E_ServiceAccessStatus {
    Disabled = 0,
    Enabled = 1,
}

/** 1/2 类型功能开关 */
export enum E_ServiceFeatureStatus {
    Enabled = 1,
    Disabled = 2,
}

/** 客户服务配置保存参数 */
export interface ICustomServiceConfigSaveParams {
    parentCompanyId: number
    /** 设备监测与故障诊断系统 */
    monitorFlag: E_ServiceAccessStatus
    /** IoT-Fast 云平台 */
    largeScreenFlag: E_ServiceAccessStatus
    /**
     * 综合可视化大屏跳转地址
     */
    largeScreenUrl?: string
    /** 健康评分训练数据倾角变化过滤 */
    hiScoreStatus: E_ServiceFeatureStatus
    /** AI 自诊断 */
    diagnosisStatus: E_ServiceFeatureStatus
    /** 免登录 */
    autoLogin: E_ServiceFeatureStatus
}

/** 客户服务配置 */
export interface ICustomServiceConfig extends ICustomServiceConfigSaveParams {
    companyName: string
}
